import { Box, Grid, IconButton, TextField, Typography } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  captchaAudio,
  captchaImage,
  refreshCaptchaAsync,
  submitCaptchaAsync,
  setUserCaptcha,
  setCaptchaSubmissionStarted,
  setCaptchaSuccessful,
} from "../../features/CaptureDetailsSlice";

export default function Captcha() {
  const dispatch = useDispatch();
  const captchaI = useSelector(captchaImage);
  const captchaA = useSelector(captchaAudio);

  const [playing, setPlaying] = React.useState(false);

  const requestNewCaptcha = () => {
    dispatch(setCaptchaSuccessful(false));
    dispatch(refreshCaptchaAsync());
    const input = document.querySelector('#captcha-input');
    if(input) {
      (input as HTMLInputElement).value = "";
      (input as HTMLInputElement).focus();
    }
  }

  useEffect(() => {
    dispatch(setCaptchaSuccessful(false));
    dispatch(refreshCaptchaAsync());
  }, [dispatch]);

  const keypressFilter = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.code === "Enter") {
      dispatch(setCaptchaSubmissionStarted(true));
      dispatch(submitCaptchaAsync());
    }
  };

  const AudCapt = new Audio(captchaA);
  AudCapt.addEventListener("play", () => setPlaying(true));
  AudCapt.addEventListener("ended", () => setPlaying(false));

  return (
    <Box sx={{ pt: "22px" }}>
      <Typography
        sx={(theme) => ({ fontSize: theme.typography.h3, pb: "12px" })}
      >
        Captcha
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={2} direction="row">
            <Grid item>
              <img src={captchaI} alt="captcha" />
            </Grid>
            <Grid item xs={2}>
              <IconButton
                color="primary"
                aria-label="audio captcha"
                component="span"
                disabled={playing}
                onClick={() => {
                  AudCapt.play();
                }}
              >
                <VolumeUpIcon />
              </IconButton>

              <IconButton
                color="primary"
                aria-label="refresh captcha"
                component="span"
                onClick={requestNewCaptcha}
              >
                <ReplayIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{ display: "flex", alignItems: "center", width: "70%" }}
        >
          <TextField
            required
            id="captcha-input"
            name="captchaText"
            label="CAPTCHA"
            onChange={({ target }) => {
              dispatch(setUserCaptcha(target.value));
            }}
            onKeyDown={keypressFilter}
            autoFocus={true}
          ></TextField>
        </Grid>
      </Grid>
    </Box>
  );
}
